/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';
import {
	RangeControl,
} from '@wordpress/components';

/**
 * Inner dependencies.
 */
import blockConst from '../constants';
const { hookPrefix } = blockConst;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-content`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/content`,
	( content, props ) => {
		const { attributes, setAttributes } = props;
		const { rating, blockAdvanceOptions } = attributes;
		const maxRating = blockAdvanceOptions?.maxRating ? blockAdvanceOptions.maxRating : 5;
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<RangeControl
					label={ __( 'Rating' ) }
					value={ rating }
					onChange={ ( value ) => {
						setAttributes( { rating: value } );
					} }
					min={ 0 }
					max={ maxRating }
					step={ .5 } />
			</Fragment>,
		];
	}
);
